module.exports = __webpack_public_path__ + "img/video-lectures.54b96cb3.svg";